import { baseQuery } from '../baseQuery';

export const postClearUserRecordLocks = async () => {
  const { data } = await baseQuery('clear-user-record-locks', {
    type: 'POST',
  });

  return data;
};
